enum WorkType {
    Temp = "Temp",
    Perm = "Perm",
}

export default WorkType;